<template>
	<div>
		<h4 class="mb-3">{{ $t('review-issues') }}</h4>

		<!-- No issues -->
		<div v-if="!validation || validation.issue_count === 0">
			<b-alert show variant="success" class="mb-3">
				{{ $t('all-{n}-rows-valid', { n: validation && validation.total_rows }) }}
			</b-alert>
			<div class="d-flex">
				<b-button variant="outline-secondary" class="mr-2" @click="$emit('back')">← {{ $t('back') }}</b-button>
				<b-button variant="primary" @click="$emit('next')">{{ $t('next') }}: {{ $t('select-timetable') }} →</b-button>
			</div>
		</div>

		<!-- Issues found -->
		<div v-else>
			<b-alert show variant="danger" class="mb-2" v-if="errorCount > 0">
				<strong>{{ errorCount }} {{ $t('rows-have-errors') }}</strong> {{ $t('csv-cannot-be-imported') }}
			</b-alert>
			<b-alert show variant="warning" class="mb-3" v-if="warningCount > 0">
				<strong>{{ warningCount }} {{ $t('rows-have-warnings') }}</strong> {{ $t('optional-data-missing') }}
			</b-alert>

			<div class="table-responsive mb-3">
				<table class="table table-sm table-bordered">
					<thead class="thead-light">
						<tr>
							<th style="width:3rem">{{ $t('row') }}</th>
							<th>{{ $t('datetime') }}</th>
							<th>{{ $t('title-/-session-type') }}</th>
							<th>{{ $t('teacher') }}</th>
							<th>{{ $t('room') }}</th>
							<th>{{ $t('issues') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="issue in validation.issues" :key="issue.line"
							:class="issue.severity === 'error' ? 'table-danger' : 'table-warning'">
							<td class="text-muted">{{ issue.line }}</td>
							<td class="small">
								<div>{{ issue.preview.date }}</div>
								<div class="text-muted">{{ issue.preview.time }}</div>
							</td>
							<td class="small">
								<div v-if="issue.preview.title">{{ issue.preview.title }}</div>
								<div class="text-muted">{{ issue.preview.session_type }}</div>
							</td>
							<td class="small text-muted">{{ issue.preview.teacher }}</td>
							<td class="small text-muted">{{ issue.preview.room }}</td>
							<td>
								<ul class="mb-0 pl-3">
									<li v-for="(p, pi) in issue.problems" :key="pi" class="small">
										{{ p.message }}
									</li>
								</ul>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

			<b-form-checkbox
				:checked="skipInvalidRows"
				@change="$emit('update:skipInvalidRows', $event)"
				class="mb-3"
				v-if="errorCount > 0"
			>
				{{ $t('skip') }} {{ errorCount }} {{ $t('rows-with-errors-and-import-the-remaining') }} {{ validation.total_rows - errorCount }}
			</b-form-checkbox>

			<div class="d-flex">
				<b-button variant="outline-secondary" class="mr-2" @click="$emit('back')">← {{ $t('back') }}</b-button>
				<b-button variant="primary" :disabled="errorCount > 0 && !skipInvalidRows" @click="$emit('next')">
					{{ $t('next') }}: {{ $t('select-timetable') }} →
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		validation:      { type: Object,  default: null },
		errorCount:      { type: Number,  default: 0 },
		warningCount:    { type: Number,  default: 0 },
		skipInvalidRows: { type: Boolean, default: false },
	},
};
</script>
